import script from "./goRinSyo0033.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0033.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0033.vue?vue&type=style&index=0&id=7c2ab5c8&lang=scss"

const __exports__ = script;

export default __exports__